import { CensusLiteMethod, NQSPlanApiMethod, UserApiMethod } from "src/app/core/api-methods/api-methods";
export class CachableRoutes {
  static getPackagesUrl: string = `${NQSPlanApiMethod.GetPackagesNewHire}`;
  static getPlanByPackageUrl: string = `${NQSPlanApiMethod.GetPlanByPackageIdNewHire}`;
  static getWrapLiteCarriersUrl: string = `${NQSPlanApiMethod.GetLiteWrapCarriers}`;
  static getNetworksLiteUrl: string = `${NQSPlanApiMethod.GetNetworksLite}`;
  static getCarriersUrl: string = `${NQSPlanApiMethod.GetCarriers}`;
  static getPostalDetails: string = `${CensusLiteMethod.PostalDetails}`;
  static getPlanRates: string = `${NQSPlanApiMethod.GetPlanRates}`;
  static getCarrierRatingRules: string = 'LiteRating/GetCarrierRatingRules?';

  public static getCachableRoutes() {
    return {
      'getCarriersUrl': this.getCarriersUrl,
      'getNetworksLiteUrl': this.getNetworksLiteUrl,
      'getWrapLiteCarriersUrl': this.getWrapLiteCarriersUrl,
      'getPackagesUrl': this.getPackagesUrl,
      'getPlanByPackageUrl': this.getPlanByPackageUrl,
      'getPostalDetails': this.getPostalDetails,
      'getCarrierRatingRules': this.getCarrierRatingRules,
      'getPlanRates': this.getPlanRates
    };
  }
}
